import * as React from 'react';
import { AnimatePresence } from 'motion/react';
import { useSelector } from '@grandvisionhq/state';
import { useFormSlot } from '../../slots/forms/form-context.js';
import '../../slots/summaries/summary-context.js';
import '../../slots/summaries/types.js';
import { HighlightedForm } from '../components/HighlightedForm.js';
import { getCompany } from '../selectors.js';

const CompanyFormContainer = (props)=>{
    const companyDetails = useSelector(getCompany);
    const { company  } = useFormSlot({
        onChange: props === null || props === void 0 ? void 0 : props.onChange
    });
    if (!company) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(AnimatePresence, null, Boolean(companyDetails) && /*#__PURE__*/ React.createElement(HighlightedForm, {
        key: "company-highlight",
        className: "checkout-step__highlight"
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, company)));
};

export { CompanyFormContainer };
//# sourceMappingURL=CompanyFormContainer.js.map
